'use strict';

import ArgValidator from 'bam-arg-validator';

/**
 * Subclasses of this base class represent a button (or link or whatever) associated with a specific game.
 * Its fields are retrieved directly (no explicit getters).  Fields unclude URL, label, etc.  This barely needs to be
 * a class rather than a plain JS object, but handling it this way lets us enforce an API.
 */
class BamButton {

    /**
     *
     * @param url The URL associated with the button. Required.
     * @param text The (language-specific) text for this button (pass null if n/a). Optional.
     * @param icon The code associated with this button's Glyphicon; generally this is a string used to build
     *   a CSS class.  Optional.
     * @param target The link's "target" attr; accepted values are "_self" and "_blank". Optional; default
     *   is "_self".
     * @param supplementaryData An object containing extra data needed to render this button; the object's keys and
     *   general structure are button-type-dependent
     * @constructor
     */
    constructor(url, text, icon, target, supplementaryData) {
        ArgValidator.validateArgs(arguments, ['url', 'text', 'icon', 'target', 'supplementaryData'],
            ['string', 'string|null', 'string', 'string|null', 'object'], [true, false, false, false, false]);
        ArgValidator.validateAllowed(target, ['_self', '_blank']);
        this.url = url;
        this.text = text;
        this.icon = icon;
        this.target = (target || '_self');
        if (supplementaryData !== undefined) {
            this.supplementaryData = supplementaryData;
        }
    }


}

export default BamButton;

